import request from '@/config'
import { CompanySchema, CompanySearch } from './company.type'

/* 公司：查询(LIST) */
export const GetCompanytListApi = (searchIpt: CompanySearch = { page_size: 10, current: 1, tenant_id: 1 }): Promise<IResponse> => {
    return request.post({ url: '/api/SysCompany/GetSysCompanyPage', data: searchIpt })
}

/* 公司：获取详细(Detail) */
export const GetCompanyInfoApi = (rowId: string): Promise<IResponse> => {
    const delParams = { tenant_id: 1, revision: 0, deleted_user_id: 1, id: rowId };
    return request.post({ url: '/api/SysCompany/GetSysCompanyInfo', data: delParams })
}

/* 公司：创建(CREATE) */
export const CreateCompanyApi = (createIpt: CompanySchema): Promise<IResponse> => {
    return request.post({ url: '/api/SysCompany/InsertSysCompany', data: createIpt })
}

/* 公司：修改(Modify) */
export const ModifyCompanyApi = (modifyIpt: CompanySchema): Promise<IResponse> => {
    return request.post({ url: '/api/SysCompany/UpdateSysCompany', data: modifyIpt })
}

/* 公司：删除(Delete) */
export const DelCompanyApi = (rowId: string): Promise<IResponse> => {
    const delParams = { tenant_id: 1, revision: 0, deleted_user_id: 1, id: rowId };
    return request.post({ url: '/api/SysCompany/DeleteSysCompany', data: delParams })
}

export const GetSysCompanyApi = (): Promise<IResponse> => {
    const delParams = { tenant_id: 1 };
    return request.post({ url: '/api/syscompany/getsyscompanylist', data: delParams })
}





